import Immutable from 'immutable';
import React from 'react';
import _ from 'underscore';
import ArrowNavigation from '../components/navigation/ArrowNavigation';
import BenefitsAndHarms from '../components/comparison/BenefitsAndHarms';
import Header from '../components/header/Header';
import HeaderWithIcon from '../components/common/HeaderWithIcon';
import OutcomesTable from '../components/outcomes/OutcomesTable';
import styles from '../styles/content.module.styl';
import TextContent from '../components/common/TextContent';
import textStyles from '../styles/texts.module.styl';

const Options = ({ location, data, pathContext }) => {
  const nodeData = data.allJsonContentsJson.edges[0].node;
  const { pageId, groupId, subPage, group } = pathContext;

  return (
    <div>
      <Header
        title={nodeData.title}
        group={group}
        location={location}
        logo={nodeData.logo}
        pageId={pageId}
        groupId={groupId}
        subPage={subPage}
      />
      <div className={styles.content}>
        <HeaderWithIcon title="Research results" type="research" />
        <TextContent content={nodeData.researchResults.content} />
        <h2>{nodeData.researchResults.outcomesComparison.title}</h2>
        <OutcomesTable
          followUp={'Happens to 100000 people'}
          intervention={nodeData.researchResults.outcomesComparison.intervention}
          comparison={nodeData.researchResults.outcomesComparison.comparison}
          absDenominator={nodeData.researchResults.outcomesComparison.absDenominator}
          outcomes={Immutable.fromJS(nodeData.researchResults.outcomesComparison.outcomes)}
          explanations={nodeData.researchResults.outcomesComparison.explanations}
        />
        <h2 className={textStyles.comparisonHeader}>Comparison</h2>

        <BenefitsAndHarms
          title={nodeData.researchResults.outcomesComparison.intervention}
          benefits={group.benefitsAndHarms.benefits}
          harms={group.benefitsAndHarms.harms}
        />

        <ArrowNavigation
          prevLink={`/${pageId}/${groupId}/facts`}
          nextLink={`/${pageId}/${groupId}/summary`}
        />
      </div>
    </div>
  );
};

export default Options;

export const query = graphql`
  query OptionsQuery($pageId: String) {
    allJsonContentsJson(filter: { pageId: { eq: $pageId } }) {
      edges {
        node {
          logo
          groups {
            name
            title
            benefitsAndHarms {
              benefits
              harms
            }
          }
          researchResults {
            content
            outcomesComparison {
              title
              intervention
              comparison
              absDenominator
              outcomes {
                name
                interventionAbsCount
                controlAbsCount
                choose
                certainty
                whatHappens
                narrativeText
              }
              explanations {
                key
                value
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/options-template.js